'use client';

import { Lock } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { useInstance } from '@/context/InstanceContext';

/**
 * Shown on a suspended self-hosted instance so students understand why starting a test
 * or buying something fails (the API answers 423). Never renders on platform builds.
 */
export function InstanceReadOnlyBanner() {
  const t = useTranslations('instanceNotice');
  const { readOnly } = useInstance();
  if (!readOnly) return null;

  return (
    <div role="status" className="border-b border-amber-200 bg-amber-50 px-4 py-2.5 text-sm text-amber-900">
      <div className="mx-auto flex max-w-5xl items-start gap-2">
        <Lock className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
        <p>{t('readOnly')}</p>
      </div>
    </div>
  );
}
